import React, { useEffect, useMemo, useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../utils/config.js";
// import { MdDeleteForever } from "react-icons/md";
import "mdbreact/dist/css/mdb.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// import 'bootstrap-css-only/css/bootstrap.min.css';
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import GlobalContext from "../../context/GlobalContext";

function CreateOraUsers() {
  const [users, setUsers] = useState([]);

  const [collaps, setCollaps] = useState(true);
  const [reload, setReload] = useState(false);

  const [allTenents, setallTenents] = useState([]);

  const { setShowMenu } = useContext(GlobalContext);

  // create randompassword
  const currentUserId = localStorage.getItem("current_user_Id");
  const [isEdit, setIsEdit] = useState(false);
  const [content, setContent] = useState("");
  const [scripts, setScripts] = useState([]);

  const getTenentData = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`, config)
      .then((res) => {
        console.log("telentData76=", res.data);
        if (res.data.length > 0) {
          const TenentData = res.data.filter((data) => {
            if (data.tenent_user_id == currentUserId) {
              return data;
            }
          });
          setallTenents(TenentData);
          // setTenents(TenentData)
          if (TenentData.length > 0) {
            setShowMenu(true);
          } else {
            setShowMenu(false);
            navigate("/default-page");
          }
          console.log("tenantData=", TenentData);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    console.log({ content });
  }, [content]);

  let bearerToken = localStorage.getItem("jwt_token");

  console.log("lin");
  //
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "multipart/form-data",
      // 'X-Wp-Nonce': '6de9be6ced',
      // 'Content-Type': 'application/json',
    },
  };

  // let bearerToken = localStorage.getItem('jwt_token');

  const navigate = useNavigate();

  let current_user_Id = localStorage.getItem("current_user_Id");
  console.log("current_user_Id=", current_user_Id);

  console.log("line804", users);

  const fetchInitialScript = (bearerToken) => {
    console.log("KKKK", {
      bearerToken,
      url: `${
        window.location.origin.includes("localhost")
          ? "http://localhost:3060"
          : window.location.origin + "/backend_cosmos"
      }/widget/tenantScript`,
    });
    axios
      .get(
        `${
          window.location.origin.includes("localhost")
            ? "http://localhost:3060"
            : window.location.origin + "/backend_cosmos"
        }/widget/tenantScript`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      )
      .then((res) => {
        console.log("jmifods fetchInitialScript res.data: ", res.data);
        if (res.data.script) {
          setScripts(res.data.script);
        }
      })
      .catch((err) => {
        console.log("jmifods failed", err.message);
      });
  };
  useEffect(() => {
    console.log({ scripts });
  }, [scripts]);

  useEffect(() => {
    let bearerToken = localStorage.getItem("jwt_token");
    getTenentData();
    if (bearerToken) {
      fetchInitialScript(bearerToken);
      fetchContent(bearerToken);
    }
  }, []);
  //   const scripts = [
  //     `<script>
  //   window.KrWidgetSettings = {
  //   apiBase: "${
  //     window.location.origin === "http://localhost:3000"
  //       ? "http://localhost:3060"
  //       : window.location.origin + "/backend_cosmos"
  //   }/widget/commonScript",
  //   displayName: "<DISPLAY_NAME>", /* IMPORTANT: Replace "<DISPLAY_NAME>" with the variable you use to capture the user's name */
  //   userEmail: "<USER_EMAIL>" /* IMPORTANT: Replace "<USER_EMAIL>" with the variable you use to capture the user's email address */
  // };
  //  </script>`,
  //     `<script> !function(){var t=window,e=t.KrWidget;if("function"==typeof e)e("update",t.KrWidgetSettings);else{var a=document,n=function(){n.c(arguments)};n.q=[],n.c=function(t){n.q.push(t)},t.KrWidget=n;var r=function(){var e=a.createElement("script");e.type="text/javascript",e.async=!0,e.src=t.KrWidgetSettings.apiBase;var n=a.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};"complete"===document.readyState?r():t.attachEvent?t.attachEvent("onload",r):t.addEventListener("load",r,!1)}}(); </script>`,
  //   ];
  const fetchContent = (bearerToken) => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-widget-script`, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((res) => {
        console.log("jmifods fetchContent res.data: ", res.data);
        if (res.data.data?.script) {
          setContent(res.data.data.script);
        } else {
          scripts[0] && setContent(scripts[0]);
        }
      })
      .catch((err) => {
        console.log("jmifods fetchContent failed", err.message);
        scripts[0] && setContent(scripts[0]);
      });
  };

  const handleRegenerate = () => {
    setContent(scripts[0]);
    postContent(bearerToken);
  };

  const postContent = (bearerToken) => {
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom-api/v1/store-widget-script`,
        { script: content },
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      )
      .then((res) => {
        console.log("jmifods successful res.data: ", res.data);
        setIsEdit(false);
      })
      .catch((err) => console.log("jmifods failed", err.message));
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText([content, scripts[1] ? scripts[1] : ""].join("\n"))
      .then(() => {
        console.log("Text copied to clipboard");
        alert("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const handleEdit = () => {
    setIsEdit(true);
  };

  const handleSave = () => {
    postContent(bearerToken);
  };

  return (
    <div>
      <div>
        <div className="row g-0">
          <div
            className={
              collaps ? "column right-column  col" : "column right-column  col "
            }
          >
            <div className="container pt-4">
              <p className="fs-2">Install the Widget on your site or app</p>
              <p>
                Copy and paste this code snippet before the{" "}
                <code>&lt;/body&gt;</code> tag on every page where you want the
                messenger to appear.
              </p>

              {isEdit ? (
                <>
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="6"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                  ></textarea>
                  <button className="btn btn-primary" onClick={handleSave}>
                    Save
                  </button>
                </>
              ) : (
                <div className="position-relative">
                  <div className="d-flex flex-column position-absolute end-0">
                    <button
                      className="btn btn-light px-2 py-1"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Edit"
                      onClick={handleEdit}
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      className="btn btn-light px-2 py-1"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Regenerate"
                      onClick={handleRegenerate}
                    >
                      <i class="bi bi-arrow-repeat"></i>
                    </button>
                  </div>
                  <SyntaxHighlighter
                    language="javascript"
                    style={docco}
                    showLineNumbers={true}
                  >
                    {`<script>
  ${content}
</script>
                    `}
                  </SyntaxHighlighter>
                </div>
              )}
              <SyntaxHighlighter
                language="javascript"
                style={docco}
                useInlineStyles={true}
                showLineNumbers={true}
              >
                {`<script>
  ${scripts[1]}
</script>`}
              </SyntaxHighlighter>

              <button className="btn btn-primary" onClick={handleCopy}>
                Copy
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateOraUsers;
